// Copyright (c) 2018 Comsearch, Inc., All rights reserved

export const SET_BULK_EDIT_BAND_OPTIONS = 'SET_BULK_EDIT_BAND_OPTIONS'
export const SET_BULK_EDIT_HIGHLIGHTED_PATH_IDS = 'SET_BULK_EDIT_HIGHLIGHTED_PATH_IDS'
export const SET_BULK_EDIT_HIGHLIGHTED_SITE_IDS = 'SET_BULK_EDIT_HIGHLIGHTED_SITE_IDS'
export const SET_BULK_EDIT_MODAL = 'SET_BULK_EDIT_MODAL'
export const SET_BULK_EDIT_PATHS = 'SET_BULK_EDIT_PATHS'
export const SET_BULK_EDIT_VISIBLE_PATH_IDS = 'SET_BULK_EDIT_VISIBLE_PATH_IDS'
export const UPDATE_BULK_EDIT_STATE = 'UPDATE_BULK_EDIT_STATE'
